/**
 * localStorage, wrapped so that a private window, a full quota or a browser
 * with site data blocked degrades to "no stored value" instead of throwing
 * halfway through a render.
 */
const PREFIX = 'mawqut.v1.';

export function readJson<T>(key: string): T | null {
  try {
    const raw = window.localStorage.getItem(PREFIX + key);
    return raw === null ? null : (JSON.parse(raw) as T);
  } catch {
    return null;
  }
}

export function writeJson(key: string, value: unknown): boolean {
  try {
    window.localStorage.setItem(PREFIX + key, JSON.stringify(value));
    return true;
  } catch {
    return false;
  }
}

export function remove(key: string): void {
  try {
    window.localStorage.removeItem(PREFIX + key);
  } catch {
    // nothing to do — the value was never readable either
  }
}
